import { useEffect, useState } from 'react';
import type { Session } from '@supabase/supabase-js';
import { supabase } from '@/lib/supabase';

type State = { session: Session | null; isLoading: boolean };

/**
 * הסשן נשמר לתקופה ארוכה בטלפון (PRD 2.6).
 * getSession קורא מהאחסון המקומי, בלי סבב לשרת.
 */
export function useSession(): State {
  const [state, setState] = useState<State>({ session: null, isLoading: true });

  useEffect(() => {
    let active = true;

    supabase.auth.getSession().then(({ data }) => {
      if (active) setState({ session: data.session, isLoading: false });
    });

    const { data: subscription } = supabase.auth.onAuthStateChange((_event, session) => {
      if (active) setState({ session, isLoading: false });
    });

    return () => {
      active = false;
      subscription.subscription.unsubscribe();
    };
  }, []);

  return state;
}
